import { flatten } from "flat"
import { cloneDeep, isEqual } from "lodash-es"
import { deepObserve, IDisposer } from "mobx-utils"

import { IReturnData } from "@/api/returnpage/type"
import stores from "@/stores"

export let disposer: IDisposer | null = null
export const formsDisposer: IDisposer | null = null
export let defaultPopupOptions: IReturnData
let lastIsChange = false // 保存上一次的isChange值

let isInitialized = false // 用于指示初始化完成的标志

class WorkflowPopupsUtils {
  /**
   * 注册监听器
   */
  registerListener() {
    disposer = deepObserve(stores.WorkflowStore, (change) => {
      const { WorkflowStore } = stores
      const { info, workFlowAction, workflowRules, popupSaveBtn } =
        WorkflowStore

      if (!isInitialized) return // 在初始化期间跳过比较
      if (change.type === "update" && change.observableKind === "object") {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isCheckRule, isCheckAction, ..._defaulInfo } =
          defaultPopupOptions?.info || {}
        const base = flatten({
          info: _defaulInfo,
          workFlowAction: defaultPopupOptions?.workFlowAction,
          workflowRules: defaultPopupOptions?.workflowRules,
        })
        const {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          isCheckRule: _isCheckRule,
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          isCheckAction: _isCheckAction,
          ..._info
        } = info || {}
        const now = flatten({
          info: _info,
          workFlowAction,
          workflowRules,
        })
        const isChange = !isEqual(base, now)
        // console.log("isChange", isChange)
        lastIsChange = isChange
        // 保存按钮，不调用次方法 （解决保存或者激活按钮，多次调用，顶部横幅会有闪现问题）
        if (!WorkflowStore.isWorkflowSaveBtn) {
          if (popupSaveBtn.active !== isChange) {
            WorkflowStore.setPopupSaveBtn("active", isChange)
          }
        }
      }
    })
    return true
  }

  initSetActive(val: boolean) {
    const { WorkflowStore } = stores
    WorkflowStore.setPopupSaveBtn("active", lastIsChange)
    WorkflowStore.setIsWorkflowSaveBtn(val)
  }

  // 完成数值初始化
  setIsInitialized() {
    isInitialized = true
  }

  /**
   * 销毁监听器
   */
  destroyListener() {
    const { WorkflowStore } = stores
    disposer && disposer()
    WorkflowStore.setPopupSaveBtn("loading", false)
    WorkflowStore.setPopupSaveBtn("active", false)
    return true
  }

  /**
   * 设置初始值
   * @param options
   */
  setInitOptions(options) {
    defaultPopupOptions = cloneDeep(options)
    return true
  }

  /**
   * 获取初始值配置
   */
  getInitOptions() {
    return defaultPopupOptions
  }
}

const workflowPopupsUtilsExample = new WorkflowPopupsUtils()

export default workflowPopupsUtilsExample
